export default {"src":"/_next/static/media/calender.6aa7f070.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};